import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "RhB",
  industry: IndustryEnum.Transport,
  name: "RhB",
  slug: "rhb",
  ...colors,
  layoutConfigs: {
    kis_a2_hoch: {
      thumbnail: "kis_a2_hoch.png",
    },
    kis_a2_quer: {
      thumbnail: "kis_a2_quer.png",
    },
  },
};
export default config;
